import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';

const sections = [
  {
    title: 'Information We Collect',
    body: 'When you contact Hexalogix Automation, we may collect information such as your name, company name, email address, phone number, project details, and any supporting information you voluntarily provide.'
  },
  {
    title: 'How We Use Information',
    body: 'We use submitted information to respond to enquiries, prepare quotations, evaluate project requirements, provide support, and improve our sales and service communication.'
  },
  {
    title: 'Sharing of Information',
    body: 'We do not sell your personal information. Information may be shared with internal technical or commercial teams and trusted service providers only when necessary to deliver our services or respond to your request.'
  },
  {
    title: 'Data Retention',
    body: 'We retain enquiry and project-related information for as long as reasonably necessary to support communication, contractual discussions, compliance, and service history.'
  },
  {
    title: 'Your Choices',
    body: 'If you want us to update or remove your enquiry information, contact us at info@hexalogixautomation.com and we will review the request in line with our legal and operational obligations.'
  }
];

export const PrivacyPage = () => {
  return (
    <>
      <SEOHead
        title="Privacy Policy | Hexalogix Automation"
        description="Privacy Policy for Hexalogix Automation covering how enquiry and contact information is collected, used, and managed."
        keywords="privacy policy Hexalogix Automation, contact data policy, enquiry data privacy"
      />

      <div className="min-h-screen bg-white">
        <section className="relative bg-[#0A0F1E] pt-16 md:pt-[106px] pb-16">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#0057B8]" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <nav className="flex items-center gap-2 text-sm text-gray-400 mb-6">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              <ChevronRight className="w-3 h-3" />
              <span className="text-gray-300">Privacy Policy</span>
            </nav>
            <h1 className="text-4xl sm:text-5xl font-black text-white mb-4">Privacy Policy</h1>
            <p className="text-lg text-gray-300 max-w-3xl">
              This policy explains how Hexalogix Automation handles information submitted through this website and related enquiry channels.
            </p>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
            {sections.map((section) => (
              <div key={section.title} className="border-b border-gray-200 pb-8">
                <h2 className="text-2xl font-black text-[#0A0F1E] mb-4">{section.title}</h2>
                <p className="text-base text-gray-700 leading-relaxed">{section.body}</p>
              </div>
            ))}
            <div>
              <h2 className="text-2xl font-black text-[#0A0F1E] mb-4">Contact</h2>
              <p className="text-base text-gray-700 leading-relaxed">
                For privacy-related questions, email <a href="mailto:info@hexalogixautomation.com" className="text-[#0057B8] hover:text-[#003D82]">info@hexalogixautomation.com</a>.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
